<template>
    <t-form labelWidth="80px" class="cpt-iconfont-option">
        <e-collapse title="基础设置" :expand="true">
            <t-form-item label="图标颜色">
                <t-color-picker size="small" :colorModes="['monochrome']" format="RGBA" enableAlpha
                    v-model="attribute.color" />
            </t-form-item>
            <t-form-item label="图标大小">
                <t-input-number size="small" :min="0" :max="9999" v-model="attribute.fontSize" :decimal-places="0" />
            </t-form-item>
            <t-form-item label="图标">
                <div class="icon-wrap">
                    <t-button size="small" @click="onOpen">选择图标</t-button>
                    <!-- iconfont -->
                    <div v-if="attribute.iconfont.font_class" :class="`iconfont icon-${attribute.iconfont.font_class}`"></div>
                </div>
            </t-form-item>
        </e-collapse>

    </t-form>


    <t-dialog class="cpt-iconfont-option-dialog" header="图片素材库" v-model:visible="modelShow" width="75%"
        :closeOnOverlayClick="false" top="50px" @confirm="confirmCheck" @cancel="onCancel">
        <!-- <t-form layout="inline">
            <t-form-item label="资源名">
                <t-input v-model="searchValue" placeholder="请输入资源名" />
            </t-form-item>
            <t-button @click="onSearch">查询</t-button>
        </t-form> -->
        <div class="list" v-loading="loading">
            <template v-for="(item, index) in listComputed">
                <div :class="{ item: true, 'current-icon': currentIcon.icon_id === item.icon_id }"
                    @click="onClickIcon(item)">
                    <div :class="`iconfont icon-${item.font_class}`"></div>
                    <p>{{ item.name }}</p>
                </div>
            </template>
        </div>
        <t-pagination :total="list.length" :showPageSize="false" v-model="currentPage" @change="onChange"
            v-model:pageSize="pageSize" />
    </t-dialog>
</template>

<script>
import { ref, watch, computed } from 'vue'
import { iconfontUrl } from '/env'

export default {
    name: "cpt-iconfont-option",
    props: {
        attribute: Object,
        cptDataForm: Object,
        currentCpt: Object,
    },
    setup(context) {
        const modelShow = ref(false)
        const searchValue = ref('')
        const loading = ref(false)
        const list = ref([])
        const currentPage = ref(1)
        const pageSize = ref(55)
        const currentIcon = ref({ icon_id: '' })

        const listComputed = computed(() => {
            const startIndex = (currentPage.value - 1) * pageSize.value;
            const endIndex = Math.min(startIndex + pageSize.value, list.value.length);
            // 假设data是所有数据的数组
            return list.value.slice(startIndex, endIndex);
        })

        const onSearch = () => {

        }
        const onOpen = () => {
            modelShow.value = !modelShow.value
        }

        const onClickIcon = (icon) => {
            currentIcon.value = icon
        }

        const onChange = value => {
            currentPage.value = value.current
        }

        const getIconfontJson = async () => {
            try {
                loading.value = true
                const resultJson = await fetch(iconfontUrl+'/iconfont.json')
                const result = await resultJson.json()
                loading.value = false
                console.log(result)
                list.value = result.glyphs
            } catch (error) {
                loading.value = false
                console.error('图标库请求失败:', error)
            }
        }
        const confirmCheck = () => {
            context.attribute.iconfont = currentIcon.value
            currentPage.value = 1
            modelShow.value = false
        }
        const onCancel = () => {
            currentIcon.value = { icon_id: '' }
            currentPage.value = 1
            modelShow.value = false
        }




        watch(() => modelShow.value, (flag) => {
            if (flag) {
                getIconfontJson()
                currentIcon.value = context.attribute.iconfont
            }
        })

        return {
            modelShow,
            searchValue,
            loading,
            list,
            pageSize,
            currentPage,
            listComputed,
            currentIcon,

            onOpen,
            onSearch,
            onChange,
            onClickIcon,
            confirmCheck
        }
    }
};
</script>

<style>
.cpt-iconfont-option-dialog .t-loading__overlay {
    background: transparent !important;
}
.cpt-iconfont-option .icon-wrap {
    display: flex;
    flex-direction: column;
}
.cpt-iconfont-option .icon-wrap .iconfont {
    font-size:50px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}
.cpt-iconfont-option-dialog .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 40px;
    min-height: 525px;
    align-content: baseline;
}

.cpt-iconfont-option-dialog .list .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    width: 100px;
    margin: 0 12px;
    margin-bottom: 35px;
    transition: .3s ease-in-out;
}

.cpt-iconfont-option-dialog .list .current-icon {
    color: #4a99ff !important;

}

.cpt-iconfont-option-dialog .list .item:hover {
    color: #4a99ff;
    transform: translateY(-5px);
}

.cpt-iconfont-option-dialog .list .item .iconfont {
    font-size: 50px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cpt-iconfont-option-dialog .list .item p {
    text-align: center;
    margin-top: 10px;
}
</style>